import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlertsComponent } from './alerts.component';

@NgModule({
  declarations: [AlertsComponent],
  imports: [CommonModule],
  exports: [AlertsComponent] // Ensure you export it if it's used in other modules
})
export class AlertsModule {}